import { defineStore } from 'pinia';
import type { ProductShippingCostData } from '../types/getProductShippingCostData';

interface ShippindCostState {
  shippingCost: ProductShippingCostData | null;
}

export const useShippindCostStore = defineStore('shippindCost', {
  state: (): ShippindCostState => ({
    shippingCost: null,
  }),
});
